import { HorizontalTabs } from '@wajeez-web/components/ui';
import { Button } from '@wajeez-web/components/ui';
import { Identity } from '@wajeez-web/core/api-base';

import UserDetailsElementForm from './UserDetailsElementForm';
import UserSubscriptionElementForm from './UserSubscriptionElementForm';
import UserGiftsElementForm from './UserGiftsElementForm';
import { UserBusiness } from './UserBusiness';

const EditUserForm = ({
  data,
  points,
  setEditUserState,
  onDeleteUser,
  getData,
}: {
  data: Identity.UserDetailsOutput;
  points: number;
  setEditUserState: React.Dispatch<React.SetStateAction<boolean>>;
  onDeleteUser: () => void;
  getData: () => void;
}) => {
  return (
    <div className=" mt-1 flex  flex-col justify-between h-full">
      <div className="px-8 ">
        {' '}
        <HorizontalTabs
          position="center"
          tabs={{
            Details: (
              <UserDetailsElementForm
                data={data}
                points={points}
                getData={getData}
              />
            ),
            Subscription: (
              <UserSubscriptionElementForm data={data} getData={getData} />
            ),
            Gifts: <UserGiftsElementForm data={data} getData={getData} />,
            Business: <UserBusiness userId={data.id} />,
          }}
        />
      </div>
      <div className="mt-4 px-8 py-2 rounded-t bg-gray-100 flex justify-end ">
        {/* <Button
          shape="circle"
          title={'Delete'}
          type="text"
          bg="red-100"
          color="red-500"
          onClick={onDeleteUser}
        /> */}
        <Button
          shape="circle"
          title={'Cancel'}
          type="text"
          bg="gray-200"
          color="textSecondary"
          onClick={() => setEditUserState(false)}
        />
      </div>
    </div>
  );
};

export default EditUserForm;
